export default "__VITE_ASSET__CJfvlY9c__"